import { useTranslation } from "react-i18next"
import { DotPill } from "../../delivery/atoms"

interface Props {
  value: boolean
  trueLabel?: string
  falseLabel?: string
}

/** Yes/no (or active/inactive) as a DotPill (canvas Ord_Settings): green dot for yes, grey for no. */
export function BooleanIndicator({ value, trueLabel, falseLabel }: Props) {
  const { t } = useTranslation("common")
  const yes = trueLabel ?? t("confirm.yes")
  const no = falseLabel ?? t("confirm.no")
  return <DotPill tone={value ? "green" : "grey"}>{value ? yes : no}</DotPill>
}
